import { CardApiClient } from '@/clients/cardApiClient';
import type { CardInput, CardRegister, CompanyCard } from '@/types/card';

export class CardService {
  private apiClient = new CardApiClient();

  listCards(companyId: string): Promise<CardRegister> {
    return this.apiClient.listCards(companyId);
  }

  createCard(companyId: string, input: CardInput): Promise<CompanyCard> {
    return this.apiClient.createCard(companyId, input);
  }

  updateCard(companyId: string, cardId: string, input: CardInput): Promise<CompanyCard> {
    return this.apiClient.updateCard(companyId, cardId, input);
  }

  deleteCard(companyId: string, cardId: string): Promise<void> {
    return this.apiClient.deleteCard(companyId, cardId);
  }
}
